import { Component } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ElementRef, HostListener, Inject, NgZone, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { BreadcrumbService } from '../../core/service/breadcrumb.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css'
})
export class LayoutComponent {
showLayout = true;
  steps = [
    { label: 'Accident Information', active: true },
    { label: 'Other Party Information', active: false },
    { label: 'Injury/Death', active: false },
    { label: 'Accident Details', active: false }
  ];
  isMobile: boolean = false;
  private scrollListener: (() => void) | undefined;
  isLogin:boolean=false;
  hideBreadCrumbs:boolean=false;

  constructor(@Inject(DOCUMENT) private document: Document,private breadcrumbService: BreadcrumbService,
    private ngZone: NgZone,private router: Router) {
 
    this.breadcrumbService.hidebread$.subscribe((value) => {
      // console.log(value,'29');
      if (value) {
        this.hideBreadCrumbs = true;
        // console.log(this.hideBreadCrumbs,'32');
      }
    });
  }

  isAuthenticated(){
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Hide layout for login page
        this.showLayout = event.url !== '/login';
      }
    });
     console.log(this.showLayout);
    return this.showLayout;

  }

  // @HostListener('window:scroll', ['$event'])
  // onWindowScroll() {
  //   console.log("scroll")
  //   const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  //   if (scrollTop <= 50) {
  //     // Execute your code he  
  //     document.getElementById('breadcrumb')?.classList.remove('onscroll-breadcrumb');
  //     console.log('50')

  //   }
  //   if (document.body.scrollTop > 20 ||
  //     document.documentElement.scrollTop > 20) {
  //     document.getElementById('breadcrumb')?.classList.add('onscroll-breadcrumb');
  //     console.log('20')
  //   }
  // }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event: Event) {
    // Access scroll event details through $event
    console.log('Window scrolled', $event);
    //To get vertical scroll offset
    console.log('Vertical offset', window.pageYOffset)
  }

  ngOnInit() {
    this.checkScreenSize();
    const header = document.querySelector('.breadcrumbs-content');
    this.scrollListener = () => {
      // Check vertical scroll position
      if (window.scrollY > 10) { // Change '10' to whatever threshold you want
        header?.classList.add('scrolled');
      } else {
        header?.classList.remove('scrolled');
      }
    };
    // Add the scroll event listener
    window.addEventListener('scroll', this.scrollListener);

  }

  @HostListener('window:resize', [])
  checkScreenSize() {
    this.isMobile = window.innerWidth <= 768; // Adjust the width as per your requirement
  }


}
